angular.module("componentes").directive("legalDocuments", [
	function () {
		"use strict";
		return {
			scope: {},
			controller: "LegalDocumentsCtrl",
			controllerAs: "ctrl",
			templateUrl: "views/login/components/legalDocuments_template.html"
		};
	}
]);
